import AuthService from '../services/authService';
import './root.scss';
import UserService from '../pages/user/services/userService'
import RootController from './rootController';

/**
 * @type {{template: *, controller: RootController}}
 */
const RootComponent = {
    template: require('./rootView.html'),
    controller: RootController
};

export default angular.module('app.root', [])
    .component('root', RootComponent)
    .service('AuthService', AuthService)
    .service('UserService', UserService)
    .name;




// WEBPACK FOOTER //
// ./src/app/root/rootComponent.js